import React, { useState, useRef, useEffect } from 'react';
import './FloatingChat.css';

const FloatingChat = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [userInput, setUserInput] = useState('');

    // Referencia para hacer scroll automático al final del chat
    const messagesEndRef = useRef(null);

    useEffect(() => {
        // Cada vez que cambien los mensajes, bajamos el scroll suavemente
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const handleSendMessage = async () => {
        if (userInput.trim() === '') return;

        const newMessages = [...messages, { from: 'user', text: userInput }];
        setMessages(newMessages);

        const inputToSend = userInput;
        setUserInput('');

        try {
            const response = await fetch("https://n8n-produccion.navitechlabs.com/webhook/chat", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message: inputToSend })
            });

            if (!response.ok) throw new Error("Error en la petición");

            const data = await response.json();

            // Añadimos la respuesta con un texto de respaldo por si falla data.myField
            setMessages(prev => [...prev, {
                from: 'bot',
                text: data.myField || "Lo siento, no pude procesar tu mensaje. ¿Puedes intentarlo de nuevo?"
            }]);

        } catch (err) {
            console.error(err);
            setMessages(prev => [...prev, { from: 'bot', text: "⚠️ Error al conectar con el servidor." }]);
        }
    };

    return (
        <>
            {!isChatOpen && (
                <button className="floating-chat-button" onClick={() => setIsChatOpen(true)}>
                    {/* Reemplazamos el emoji por un icono SVG más limpio */}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <span>Asistente IA</span>
                </button>
            )}

            {isChatOpen && (
                <div className="chat-window">
                    <div className="chat-header">
                        <div className="chat-header-info">
                            <div className="chat-avatar">
                                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                            </div>
                            <span>NAVI Assistant</span>
                        </div>
                        <button className="close-button" onClick={() => setIsChatOpen(false)}>✕</button>
                    </div>

                    <div className="chat-body">
                        {/* Mensaje de bienvenida inicial */}
                        {messages.length === 0 && (
                            <div className="chat-welcome">
                                ¡Hola! Soy el asistente de IA de NAVI. ¿En qué puedo ayudarte hoy?
                            </div>
                        )}

                        {messages.map((msg, i) => (
                            <div key={i} className={`chat-message-wrapper ${msg.from}`}>
                                <div className={`chat-message ${msg.from}`}>
                                    {msg.text}
                                </div>
                            </div>
                        ))}
                        {/* Div invisible para el scroll automático */}
                        <div ref={messagesEndRef} />
                    </div>

                    <div className="chat-input">
                        <input
                            type="text"
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
                            placeholder="Escribe tu mensaje..."
                            autoFocus
                        />
                        <button onClick={handleSendMessage}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default FloatingChat;